import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import Icons from '../../Elements/Icons/index.js';
import { Loader } from '../../Elements/Loader/index.js';
import Typography from '../../Typography/index.js';
import { Content, Header, IconWrapper, Indicator, ItemWrapper, Label, Row, TextValue, Value } from './styled.js';
const PLACEHOLDER = '—';
export const InfoCardItem = memo(function InfoCardItem({ title, value, icon, indicatorColor, headline = true, columnSpan, pending, dataTestId, }) {
    const Icon = icon ? Icons[icon.name] : null;
    const renderBody = () => {
        if (pending) {
            return _jsx(Loader, {});
        }
        if (Array.isArray(value)) {
            return (_jsx(Content, { children: value.map((row, index) => (_jsxs(Row, { children: [row.label && _jsx(Label, { children: row.label }), _jsx(Value, { "data-testid": row.dataTestId, children: row.value || PLACEHOLDER })] }, `${row.label ?? row.value}-${index}`))) }));
        }
        return headline ? _jsx(Typography.Headline, { children: value || PLACEHOLDER }) : _jsx(TextValue, { children: value || PLACEHOLDER });
    };
    return (_jsxs(ItemWrapper, { $columnSpan: columnSpan, "data-testid": dataTestId, children: [_jsxs(Header, { $headline: headline, children: [indicatorColor ? _jsx(Typography.TextMedium, { children: title }) : _jsx(Typography.TextLarge, { children: title }), icon && Icon && (_jsx(IconWrapper, { $iconBackgroundColor: icon.backgroundColor, children: _jsx(Icon, { color: icon.color, filled: icon.filled ?? true, size: 20 }) })), indicatorColor && _jsx(Indicator, { $color: indicatorColor })] }), renderBody()] }));
});
